<template>
	<div class="page-settings">
		<div class="page-settings__wrapper">
			<div class="page-settings__container">
				<div class="page-settings__header">
					<h1 class="section-title section-title--page-settings">IP Logs</h1>
					<div class="notification-wrap-center">
						<PartNotifications v-if="notificationsData.msg" :data="notificationsData"/>
					</div>
				</div>
			</div>
			<div class="table-wrap">
				<BlockTable
					v-if="!noResults"
					:data="DashboardPropertiesData"
					class="page-settings-table"
					@deleteRow="deleteRow"
					@sortData="sortProperties"
				/>

				<PartLoaderBig v-if="preloader"/>

				<PartNoResults :data="DataNoResults" v-if="noResults && !preloader"/>

				<PartPagination
					ref="pagination"
					v-show="!preloader && showPagination"
					@getPage="getPage"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import PartPagination from '@/components/parts/PartPagination';
import PartLoaderBig from '@/components/parts/PartLoaderBig';

export default {
	props: {
		data: {
			type: Object,
			required: false
		}
	},
	data: () => {
		return {
			DataNoResults: {},
			noResults: true,
			notificationsData: {
				type: '',
				msg: ''
			},
			showPagination: false,
			preloader: true,
			localOrder: 'desc',
			localOrderBy: 'id',
			DashboardPropertiesData: {
				stickyHeader: true,
				noLocalSorting: false,
				noCollapse: false,
				fields: [
					{ key: 'ip', label: 'IP', sortable: true, stickyColumn: true, variant: 'ip thead-lg' },
					{ key: 'user', label: 'User', sortable: true, stickyColumn: true, variant: 'user' },
					{ key: 'date', label: 'Date', sortable: true, stickyColumn: true, variant: 'date' }
				],
				items: []
			}
		};
	},
	components: {
		PartPagination,
		PartLoaderBig
	},
	methods: {
		fetchNewActiveProperties(obj) {
			this.DashboardPropertiesData.items = [];

			// setTimeout(() => {
			this.preloader = true;
			// }, 100);

			return this.$store.dispatch('fetchProperties', obj);
		},
		sortProperties(item) {
			const obj = {
				order_by: item,
				order: this.SortOrder(item),
				page: 1
			};
			this.localOrderBy = item;
			this.fetchNewActiveProperties(obj).then(response => {
				this.$refs.pagination.updateDataPag(response.data);
				this.preloader = false;
			});
		},
		SortOrder(item) {
			if (this.localOrderBy === item) {
				if (this.localOrder === 'asc') {
					this.localOrder = 'desc';
				} else {
					this.localOrder = 'asc';
				}
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		getPage(page, $ref) {
			const obj = {
				order_by: this.localOrderBy,
				order: this.localOrder,
				page: page
			};
			this.fetchNewActiveProperties(obj).then(response => {
				$ref.updateDataPag(response.data);
				this.preloader = false;
			});
		},
		checkPagination(data) {
			this.showPagination = data.prev_page_url !== null || data.next_page_url !== null;
		},
		notification(response) {
			this.notificationsData.msg = response.data.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		}
	}
};
</script>
<style lang="scss" scoped>
.page-settings {
	padding-top: 43px;
    padding-left: 3px;
	padding-bottom: 40px;

	@include mq($xl) {
		padding-left: 0;
		padding-top: 20px;
		padding-bottom: 20px;
	}
}

.section-title--page-settings {
	margin-bottom: 40px;

	@include mq($lg) {
		margin-bottom: 20px;
	}
}

.page-settings__header {
	position: relative;
}

.page-settings__wrapper {
	padding: 0 15px;

	@include mq($xl) {
		padding: 0;
	}
}

.table-wrap {
	min-height: 300px;
}
</style>
